module.exports = __webpack_public_path__ + "img/overall.eead1051.png";